//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'VFCCode',
    props: ['status'],
    data () {
        return {
            randkey: '',
            imgSrc: '',
            code: ['', '', '', ''],
            isShow: false
        }
    },
    methods: {
        submit () {
            let _code = this.code.join('')
            if (_code.length === 4) {
                this.$emit('dealCode', {randKey: this.randKey, code: _code})
            }
        },
        changeCode (i) {
            if (this.code[i].length === 1) {
                document.getElementById('codeId' + (i + 1)).focus()
            }
        },
        close () {
            this.$emit('close', 0)
        },
        refreshCode () {
            this.code = []
            this.imgSrc = 'https://api.roseonly.com.cn/user/getVerify?t=' + Math.random()
            // this.imgSrc = 'http://api.huakai.com/user/getVerify?t=' + Math.random()
        }
    },
    created () {
        // this.$http.get('/user/getVerify', {params: {}}).then(res => {
        //     console.log(res)
        //     // this.randkey = res.data
        //     // this.imgSrc = 'https://orders.roseonly.com.cn/newImage.jsp?randKey=' + this.randkey
        //     // this.imgSrc = res.data
        // })
        this.refreshCode()
    },
    watch: {
        status (v) {
            this.isShow = v
        }
    }
}
